import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Stack, Tab, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import Roles from "../../../../common/enums/Roles";
import TourProgramApprovalTab from "./sub-component/TourProgramApproval";
import TourDeviationApproval from "./sub-component/TourDeviationApproval";

const UserReturnAcknowledgementDesktop = () => {
  const TAB_STORAGE_KEY = "tour_program_deviation_approval_tab";

  const { userRole, decodeToken } = CustomerDatabaseStore();
  const [value, setValue] = useState<string>("tour_program_approval");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    decodeToken();
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const storedTab = localStorage.getItem(TAB_STORAGE_KEY);

    if (storedTab === "tour_program_approval" || storedTab === "tour_deviation_approval") {
      setValue(storedTab);
    } else {
      setValue("tour_program_approval");
      localStorage.setItem(TAB_STORAGE_KEY, "tour_program_approval");
    }
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    localStorage.setItem(TAB_STORAGE_KEY, newValue);
  };

  if (loading) return null;

  if (userRole?.role === Roles.HEADQUATER_MANAGER) {
    return null; 
  }

  return (
    <Stack sx={{ position: "relative" }}>
      <TabContext value={value}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          flexDirection={{ xs: "column", md: "row" }}
        >
          <Box sx={{ flex: "0 0 auto", minWidth: "200px" }}>
            <Typography variant="h5" fontWeight={550}>
              Tour Program Approvals
            </Typography>
          </Box>
        </Box>

        <TabList onChange={handleChange} sx={{ ml: 2 }}>
          <Tab label="Tour Program Approval" value="tour_program_approval" />
          <Tab label="Tour Deviation Approval" value="tour_deviation_approval" />
        </TabList>

        <TabPanel sx={{ p: 0 }} value="tour_program_approval">
          <TourProgramApprovalTab />
        </TabPanel>
        <TabPanel sx={{ p: 0 }} value="tour_deviation_approval">
          <TourDeviationApproval />
        </TabPanel>
      </TabContext>
    </Stack>
  );
};

export default UserReturnAcknowledgementDesktop;
